import { ReactNode } from 'react';
import styled, { css } from 'styled-components';

interface DropdownMenuProps {
  isOpen?: boolean;
  children?: ReactNode;
}

export const DropdownMenu = styled.div<DropdownMenuProps>`
  overflow: auto;
  max-height: calc(0.8 * 100vh);
  right: 0;
  top: -100%;
  opacity: 0;
  margin-top: 0.5;
  position: absolute;
  transition: all 0.5s linear;
  min-width: 198px;
  z-index: -1;
  pointer-events: none;

  ${({ isOpen }) =>
    isOpen &&
    css`
      top: 100%;
      opacity: 1;
      z-index: 99999;
      pointer-events: fill;
    `}
`;

interface StyledProps {
  children?: ReactNode;
}

export const DropdownList = styled.ul<StyledProps>`
  background-color: ${({ theme }) => theme.palette.primary.main};
  margin: 0;
  padding: 0;
`;

export const DropdownListItem = styled.li<StyledProps>`
  list-style: none;
  padding: 9px 11px 8px;
`;

interface DropdownHeaderProps {
  children?: ReactNode;
  onClick?: any;
  ref?: any;
}

export const DropdownHeader = styled.div<DropdownHeaderProps>``;

interface DropdownContainerProps {
  children?: ReactNode;
  onClick?: any;
  ref?: any;
}

export const DropdownContainer = styled.div<DropdownContainerProps>`
  position: relative;
  height: 100%;
`;
